import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAppStateStore } from "@/store/app-state";


export default /*#__PURE__*/_defineComponent({
  __name: 'SplitViewTypeButton',
  setup(__props) {

const state = useAppStateStore();

function toggleSplitView() {
	console.log("Split button clicked");
	if(state.splitViewType == "split"){
		state.splitViewType = "sideBySide";
	}else{
		state.splitViewType = "split";
	}
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["split-view-type-button", {'side-by-side': _unref(state).splitViewType == 'sideBySide'}]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSplitView()))
  }, null, 2))
}
}

})